<template>
  <div id="app" class="index">
    <el-container class="container">
      <el-header class="header">
        <PageHeader></PageHeader>
      </el-header>

      <el-main class="main">
        <router-view></router-view>
      </el-main>

      <el-footer class="footer">
        <PageFooter></PageFooter>
      </el-footer>
    </el-container>


  </div>
</template>

<script>
import PageHeader from "./components/PageHeader";
import PageFooter from "./components/PageFooter";

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter
  },
}
</script>


<style>
.header {
  color: #333;
  line-height: 60px;
  padding: 0;
}
.index {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.container {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content:space-between;
}
.main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-top: 1px;
}
.footer {
  /*height: 4vh;*/
  width: 100%;
  align-items: center;
  padding: 0;
}

#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/App.vue